import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "animate.css/animate.compat.css"
import { Analytics } from "@vercel/analytics/react"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <>
  <App />
  <Analytics/> 
  </>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


// // ✅ React 17
// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import "animate.css/animate.compat.css"
// import { Analytics } from "@vercel/analytics/react"

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   <Analytics/> 
//   </React.StrictMode>,
//   document.getElementById('root')
// );
